<footer class="app-footer">
  <span class="footer-copy">&copy; {{ currentYear }} {{ companyName }}. {{ 'FOOTER.ALL_RIGHTS_RESERVED' | translate }}</span>
  <div class="footer-links">
    <span class="footer-version">v{{ version }}</span>
  </div>
</footer>
